import type { Locale } from "@twm/shared";

/** Explicit marketing handoff wins over a previous browser preference. */
export function initialAdminLanguage(search: string, stored: string | null): Locale {
  const values = new URLSearchParams(search).getAll("lang");
  if (values.length === 1 && (values[0] === "el" || values[0] === "en")) return values[0];
  return stored === "en" ? "en" : "el";
}
